import {Component,  Vue, Ref} from 'vue-facing-decorator';
import { ref } from "vue";
import {authLogout} from '@/utils/auth';
import ax from '@/utils/axios';

@Component({
    name: 'app-user-menu',
})
export default class UserMenu extends Vue{
    @Ref('menu') menuRef!: { toggle: (event: Event) => void };
    
    public checkDark : any  = ref(false);
    public username   = ref('');
    is_loading = false;

    changeDark(){
        this.checkDark = !this.checkDark;
        this.setUserUI('is_dark', this.checkDark );
        //this.$store.dispatch('ui/onChangeDarkTheme', this.checkDark); 
    }

    checkMode : any = ref();
    changeMode(){
        //this.$store.dispatch('ui/layoutSidebarMode'); 
        if ( this.checkMode === 'static') {
            this.checkMode =  'overlay';
        }
        else if ( this.checkMode === 'overlay') {
            this.checkMode = 'static';
        }
        this.setUserUI('layout_sidebar_mode', this.checkMode);
        //this.checkMode = this.$store.getters['ui/layoutSidebarMode'];
    }

    async setUserUI(field : any, val : any){
        this.is_loading = true;
        const id        = this.$store.getters['user/getUser'];
        const url       = 'user/set_ui/' + id.id;
        const formData  = new FormData();
        formData.append('_method', 'PUT');
        formData.append(field, val);
        await ax.post(url, formData).then((res : any ) => {
            if(res.data.status){
                this.checkDark  = res.data.data.ui.is_dark ;
                this.checkMode  = res.data.data.ui.layout_sidebar_mode;

                this.$store.dispatch('user/setUser', res.data.data);
                this.$store.dispatch('ui/setLayoutSidebarMode'  , this.checkMode);
                this.$store.dispatch('ui/onChangeDarkTheme'     , this.checkDark);
                
                this.$toast.add({ severity: 'success',  summary: 'Berhasil Update UI!!', detail: res.data.message, life: 3000 });
            }else{
                this.$toast.add({ severity: 'warn',  summary: 'Gagal Update UI!!', detail: res.data.message, life: 3000 });
            }
            this.is_loading = false;
            //console.log(res.data.data.ui)
        }).catch((err : any) => {
            console.log(err)
            this.is_loading = false;
            this.$toast.add({ severity: 'warn',  summary: 'Gagal Update UI!!', detail: err.message, life: 3000 });
            if(err.response){
                this.$toast.add({ severity: 'error',  summary: err.message, detail: err.response.data.message, life: 3000 });
            }
            this.is_loading = false;
        })
    }


    onLogout(){
        const auth_status : any =  authLogout();
        auth_status.then((res : any) => {
            if(res){
                this.$toast.add({ severity: 'success',  summary: 'Logout', detail: res.message, life: 3000 });
            }else{
                this.$toast.add({ severity: 'warn',  summary: 'Logout', detail: res.message, life: 3000 });
            }
        }).catch((error : any) => {
            this.$toast.add({ severity: 'error',  summary: 'Logout', detail: error.message, life: 3000 });
            this.$router.push('/login');
        });

        if (auth_status) {
            this.$router.push('/login');
        }
    }


    get user(): any {
        return this.$store.getters['user/getUser'];
    }

    private toggle(event: Event): void {
        this.menuRef.toggle(event);
    }

    items = [
        {
            separator: true
        },
        {
            label: 'Profile',
            items: [
                {
                    label: 'My Profil',
                    icon: ['fas', 'user'],
                    to : '/user_profil'
                },
                {
                    label: 'Users List',
                    icon: ['fas', 'users'],
                    to : '/user_list'
                },
                {
                    label: 'Settings',
                    icon: ['fas', 'user-gear'],
                    to : { name : 'user_profil', params: { username : this.username , tab: 'setting' }}
                },
                {
                    separator: true
                },
                {
                    label: 'About App',
                    icon: ['fas', 'circle-exclamation'],
                    to : '/about'
                },
            ]
        },
        {
            separator: true
        }
    ];

    mounted(){
        this.username  = this.user.username
        this.checkDark = this.$store.getters['ui/darkTheme'];
        this.checkMode = this.$store.getters['ui/layoutSidebarMode'];
    }
}